export default __webpack_public_path__ + "assets/products/product-sauna.b156c5f5d74b84507a4230f00870d912.webp";